// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container___rB6I","invalid":"TextArea_invalid__3-uJN"};